const tab_sections = {
    identity: 'Tożsamość',
    integrations: 'Połączenia',
    login_security: 'Logowanie i bezpieczeństwo',
    permissions: 'Uprawnienia',
    automation: 'Automatyzacja',
    platform: 'Platforma',
    overview: 'Przegląd',
    authentication: 'Uwierzytelnianie',
    authorization: 'Autoryzacja',
    users: 'Użytkownicy',
    developer: 'Deweloper',
    tenant: 'Najemca',
};
export default Object.freeze(tab_sections);
